import React from "react";
import { Box, MenuItem, Separator } from "@showitinc/showit-wc";
import ContextMenuWrapper from "./ContextMenuWrapper";
import uiPrefix from "../../utils/UiPrefixUtils";
import AppConstants from "../../constants/AppConstants";
import UserEventConstants from "../../constants/UserEventConstants";

import UIActions from "../../actions/UIActions";
import DocumentStore from "../../document/DocumentStore";
import { COMMANDS } from "../../document/commands";
import UserActions from "../../actions/UserActions";
import styles from "./SitePanelBlockContextMenu.module.css";

const { CONTEXT_ITEM_BUTTON, ITEM_TYPE_SITE_BLOCK, MODAL_ACTION_CONFIRM } = AppConstants;
const { EVENT_SITE_CANVAS_DELETE } = UserEventConstants;

/**
 * Renders a dropdown menu for a site canvas in the pages panel
 * @component
 * @param {Object} props -
 * @param {Object} props.block - The page object
 * @param {boolean} props.active - Indicates if the block is selected
 * @returns {React.ReactElement}
 */
const SitePanelBlockContextMenu = ({ block, active }) => {
  const id = block.get("id");
  const name = block.get("name");
  const slug = block.get("slug");

  const _rename = (e) => {
    e.preventDefault();
    UIActions.toggleRenamePopup({
      title: "Site Canvas",
      itemType: ITEM_TYPE_SITE_BLOCK,
      itemId: id,
      name,
      slug,
      showWarning: false,
    });
  };

  const _duplicate = (e) => {
    e.preventDefault();
    if (block) {
      DocumentStore.dispatch({ type: COMMANDS.DUPLICATE_BLOCK, payload: { id, siteCanvas: true } });
      UserActions.trackEvent({
        event: "site-canvas-duplicate",
        meta: { block: slug },
      });
    }
  };

  const _removeBlockConfirmed = () => {
    if (block) {
      DocumentStore.dispatch({ type: COMMANDS.REMOVE_SITE_BLOCK, payload: { block } });
      UserActions.trackEvent({ event: EVENT_SITE_CANVAS_DELETE, meta: { block: slug } });
    }
  };

  const _removeBlock = (e) => {
    e.preventDefault();
    UIActions.modalOpen(MODAL_ACTION_CONFIRM, {
      title: "Delete Site Canvas",
      question: "Are you sure you want to delete this site canvas?",
      message:
        "This removes a site canvas from design and will affect all pages the canvas was used on.",
      confirmBtn: "Delete",
      confirmAction: _removeBlockConfirmed,
    });
  };

  return (
    <ContextMenuWrapper icon="menuMoreHoriz" active={active}>
      <MenuItem data-e2e={uiPrefix(`rename-${CONTEXT_ITEM_BUTTON}`)} onClick={_rename}>
        Rename
      </MenuItem>
      <MenuItem data-e2e={uiPrefix(`duplicate-${CONTEXT_ITEM_BUTTON}`)} onClick={_duplicate}>
        Duplicate
      </MenuItem>
      <Separator variant="context-menu" />
      <MenuItem data-e2e={uiPrefix(`delete-${CONTEXT_ITEM_BUTTON}`)} onClick={_removeBlock}>
        <Box className={styles.delete}>Delete</Box>
      </MenuItem>
    </ContextMenuWrapper>
  );
};

export default SitePanelBlockContextMenu;
